import { render, staticRenderFns } from "./member_area.vue?vue&type=template&id=bd75f88c&scoped=true&"
import script from "./member_area.vue?vue&type=script&lang=js&"
export * from "./member_area.vue?vue&type=script&lang=js&"
import style0 from "./member_area.vue?vue&type=style&index=0&id=bd75f88c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd75f88c",
  null
  
)

export default component.exports